import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import { breakpoints } from '../helpers/breakpoints';
import festivalHomesLogo from '../../static/festival-homes-logo.svg';
import festivalHomesLogoWhite from '../../static/festival-homes-logo-white.svg';

import { StyledNavWrapper, StyledNav, StyledNavLink } from './styled-nav-elements';

const mainNavLinks = [
  {
    name: 'Festivals',
    link: '/festivals/',
  }
  // {
  //   name: 'Styleguide',
  //   link: '/styleguide',
  // },
];

const StyledNavDesktop = styled(StyledNav)`
  display: none;
  @media screen and (min-width: ${breakpoints.md}) {
    display: flex;
  }
`;

const StyledNavToggle = styled.button`
  all: unset;
  background: ${props => (props.toggleNav ? 'var(--c-white)' : 'var(--c-red)')};
  margin-left: auto;
  z-index: 10;
  width: 2rem;
  height: 2rem;
  border: 0;
  border-radius: 4rem;
  padding: 1rem;
  svg {
    display: block;
    transition: all 0.25s ease;
    width: 80%;
    margin: auto;
    transform: ${props => (props.toggleNav ? 'rotate(90deg)' : 'rotate(0deg)')};
  }
  @media screen and (min-width: ${breakpoints.md}) {
    display: none;
  }
`;

const StyledNavMobileWrapper = styled.div`
  background: var(--c-red);
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  /* display: ${props => (props.toggleNav ? 'flex' : 'none')}; */
  opacity: ${props => (props.toggleNav ? 1 : 0)};
  pointer-events: ${props => (props.toggleNav ? 'auto' : 'none')};
  z-index: 10;
  transition: opacity .20s ease;
  height: 100%;
  overflow: scroll;
  @media screen and (min-width: ${breakpoints.md}) {
    display: none;
  }
`;

const StyledNavMobile = styled.nav`
  padding: 15rem var(--gutter);
  display: flex;
  flex-direction: column;
  @media screen and (min-width: ${breakpoints.md}) {
    display: none;
  }
`;

const StyledNavMobileLink = styled(Link)`
  color: var(--c-white);
  font-size: 2rem;
  margin-bottom: 2.5rem;
  text-decoration: none;
  align-self: flex-start;
`;

const StyledNavLogo = styled(Link)`
  position: relative;
  z-index: 100;
`;

const Nav = () => {
  const [toggleNav, setToggleNav] = useState(false);
  useEffect(() => {
    toggleNav ? document.body.classList.add('scroll-lock') : document.body.classList.remove('scroll-lock');
  });
  return (
    <StyledNavWrapper>
      <StyledNavLogo aria-label={'Homepage'} to={'/'}>
        <svg width="200px" height="37px" viewBox="0 0 200 37" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="festival-homes-logo">
              <g id="Letters" transform="translate(47.000000, 10.000000)" fill={toggleNav ? '#FFFFFF' : '#2E3235'}>
                <path
                  d="M32.5678392,13.2953403 C32.5678392,15.8421654 30.3544998,16.9271357 27.9629968,16.9271357 C25.7496574,16.9271357 24.0639561,16.0842851 23.2028323,14.293513 L26.0808588,12.6534947 C26.3686615,13.4940612 26.9876656,13.9600274 27.9629968,13.9600274 C28.7601645,13.9600274 29.1576062,13.7179077 29.1576062,13.2724989 C29.1576062,12.055048 23.7121974,12.6968936 23.7121974,8.8663773 C23.7121974,6.454317 25.7496574,5.2368661 28.0520786,5.2368661 C29.8451348,5.2368661 31.4394701,6.0340338 32.3691183,7.6055276 L29.5344906,9.1336227 C29.2261307,8.5603015 28.7830059,8.1605756 28.0520786,8.1605756 C27.4764733,8.1605756 27.1224303,8.382138 27.1224303,8.7818639 C27.1224303,10.0427136 32.5678392,9.199863 32.5678392,13.2953403"
                  id="Fill-4"
                ></path>
                <path
                  d="M138.762905,9.9305619 C138.411147,8.6468707 137.412974,8.1809045 136.417085,8.1809045 C135.156236,8.1809045 134.313385,8.7999086 134.002741,9.9305619 L138.762905,9.9305619 Z M136.723161,13.959799 C137.632252,13.959799 138.408862,13.6057561 138.851987,13.1169484 L141.510735,14.6450434 C140.421197,16.1502969 138.785747,16.9269073 136.679762,16.9269073 C132.899497,16.9269073 130.549109,14.3823664 130.549109,11.0817725 C130.549109,7.7834628 132.940612,5.2366377 136.437643,5.2366377 C139.667428,5.2366377 142.061215,7.7377798 142.061215,11.0817725 C142.061215,11.5477387 142.015532,11.9885793 141.92645,12.4111466 L134.066697,12.4111466 C134.489265,13.5623572 135.510279,13.959799 136.723161,13.959799 Z"
                  id="Fill-16"
                  fillRule="nonzero"
                ></path>
                <path
                  d="M128.833486,9.8211512 L128.833486,16.6187757 L125.514619,16.6187757 L125.514619,10.1089539 C125.514619,9.0011421 124.984696,8.2930562 123.922567,8.2930562 C122.812471,8.2930562 122.193467,9.0673824 122.193467,10.373915 L122.193467,16.6187757 L118.8746,16.6187757 L118.8746,10.1089539 C118.8746,9.0011421 118.342394,8.2930562 117.277981,8.2930562 C116.174737,8.2930562 115.553449,9.0673824 115.553449,10.373915 L115.553449,16.6187757 L112.232298,16.6187757 L112.232298,5.5475103 L115.553449,5.5475103 L115.553449,6.5639561 C116.062814,5.8124714 117.035861,5.234582 118.520557,5.234582 C119.824806,5.234582 120.800137,5.7667885 121.421425,6.6964367 C122.040429,5.8101873 123.059159,5.234582 124.632937,5.234582 C127.177478,5.2368661 128.833486,7.055048 128.833486,9.8211512"
                  id="Fill-15-2"
                ></path>
                <path
                  d="M107.038145,11.0826862 C107.038145,9.5111923 105.930333,8.4696208 104.49132,8.4696208 C103.050023,8.4696208 101.944495,9.5111923 101.944495,11.0826862 C101.944495,12.65418 103.050023,13.6957515 104.49132,13.6957515 C105.930333,13.6957515 107.038145,12.65418 107.038145,11.0826862 M98.625628,11.0826862 C98.625628,7.7843764 101.238693,5.2375514 104.49132,5.2375514 C107.743947,5.2375514 110.357012,7.7843764 110.357012,11.0826862 C110.357012,14.38328 107.743947,16.9278209 104.49132,16.9278209 C101.238693,16.9278209 98.625628,14.38328 98.625628,11.0826862"
                  id="Fill-14"
                  fillRule="nonzero"
                ></path>
                <polygon
                  id="Fill-13"
                  points="96.643444 1.1185473 96.643444 16.6164915 93.100731 16.6164915 93.100731 10.4607127 88.230927 10.4607127 88.230927 16.6164915 84.68593 16.6164915 84.68593 1.1185473 88.230927 1.1185473 88.230927 7.0527638 93.100731 7.0527638 93.100731 1.1185473"
                ></polygon>
                <polygon id="Fill-12" points="73.294655 16.61672 76.615806 16.61672 76.615806 0.45408862 73.294655 0.45408862"></polygon>
                <path
                  d="M67.544998,11.0826862 C67.544998,9.4221106 66.43947,8.3828232 64.911375,8.3828232 C63.385564,8.3828232 62.277752,9.4221106 62.277752,11.0826862 C62.277752,12.7432618 63.385564,13.7825491 64.911375,13.7825491 C66.43947,13.7825491 67.544998,12.7432618 67.544998,11.0826862 Z M70.866149,5.5481955 L70.866149,16.6171768 L67.544998,16.6171768 L67.544998,15.5778894 C66.816354,16.4161718 65.731384,16.9278209 64.248972,16.9278209 C61.348104,16.9278209 58.956601,14.38328 58.956601,11.0826862 C58.956601,7.7843764 61.350388,5.2375514 64.248972,5.2375514 C65.731384,5.2375514 66.816354,5.7492005 67.544998,6.5874829 L67.544998,5.5481955 L70.866149,5.5481955 Z"
                  id="Fill-11"
                  fillRule="nonzero"
                ></path>
                <polygon
                  id="Fill-10"
                  points="58.744175 5.5472819 54.648698 16.6162631 50.8844221 16.6162631 46.7889447 5.5472819 50.4641389 5.5472819 52.7665601 12.5664687 55.068981 5.5472819"
                ></polygon>
                <path
                  d="M42.2530836,16.61672 L45.576519,16.61672 L45.576519,5.5477387 L42.2530836,5.5477387 L42.2530836,16.61672 Z M41.9218821,2.5806304 C41.9218821,1.4956601 42.8286889,0.58656921 43.9136592,0.58656921 C44.9986295,0.58656921 45.9077204,1.4956601 45.9077204,2.5806304 C45.9077204,3.6656007 45.0009137,4.5746916 43.9136592,4.5746916 C42.8264048,4.5746916 41.9218821,3.6656007 41.9218821,2.5806304 Z"
                  id="Fill-8"
                  fillRule="nonzero"
                ></path>
                <path
                  d="M38.0986752,8.7359525 L38.0986752,12.6532663 C38.0986752,13.6057561 38.9164002,13.6948378 40.3782549,13.6057561 L40.3782549,16.6162631 C36.0406578,17.0593878 34.777524,15.7528552 34.777524,12.6532663 L34.777524,8.7359525 L33.0073093,8.7359525 L33.0073093,5.5472819 L34.777524,5.5472819 L34.777524,3.4435815 L38.0986752,2.447693 L38.0986752,5.5472819 L40.3782549,5.5472819 L40.3782549,8.7359525 L38.0986752,8.7359525 Z"
                  id="Fill-6"
                ></path>
                <path
                  d="M152.082001,13.2953403 C152.082001,15.8421654 149.868661,16.9271357 147.479443,16.9271357 C145.263819,16.9271357 143.580402,16.0842851 142.71471,14.293513 L145.595021,12.6534947 C145.882823,13.4940612 146.501827,13.9600274 147.479443,13.9600274 C148.27661,13.9600274 148.669484,13.7179077 148.669484,13.2724989 C148.669484,12.055048 143.224075,12.6968936 143.224075,8.8663773 C143.224075,6.454317 145.263819,5.2368661 147.563956,5.2368661 C149.357012,5.2368661 150.949063,6.0340338 151.880996,7.6055276 L149.046368,9.1336227 C148.735724,8.5603015 148.294884,8.1605756 147.56624,8.1605756 C146.990635,8.1605756 146.636592,8.382138 146.636592,8.7818639 C146.636592,10.0427136 152.082001,9.199863 152.082001,13.2953403"
                  id="Fill-17"
                ></path>
                <path
                  d="M19.2489721,9.9305619 C18.8949292,8.6468707 17.8990407,8.1809045 16.9031521,8.1809045 C15.6423024,8.1809045 14.7994518,8.7999086 14.4888077,9.9305619 L19.2489721,9.9305619 Z M17.2115121,13.959799 C18.1183189,13.959799 18.8949292,13.6057561 19.3380539,13.1169484 L21.9968022,14.6450434 C20.9095477,16.1502969 19.2718136,16.9269073 17.1681133,16.9269073 C13.38328,16.9269073 11.0351759,14.3823664 11.0351759,11.0817725 C11.0351759,7.7834628 13.4266788,5.2366377 16.9259936,5.2366377 C20.158063,5.2366377 22.549566,7.7377798 22.549566,11.0817725 C22.549566,11.5477387 22.5038831,11.9885793 22.4148013,12.4111466 L14.555048,12.4111466 C14.9753312,13.5623572 15.9940612,13.959799 17.2115121,13.959799 Z"
                  id="Fill-2"
                  fillRule="nonzero"
                ></path>
                <polygon
                  id="Fill-1"
                  points="3.737323 4.5312928 3.737323 7.5189584 9.493376 7.5189584 9.493376 10.9291914 3.737323 10.9291914 3.737323 16.6190041 0.1946094 16.6190041 0.1946094 1.1187757 9.6052992 1.1187757 9.6052992 4.5290087 3.737323 4.5290087"
                ></polygon>
              </g>
              <g id="Icon" fill={toggleNav ? '#FFFFFF' : '#E84955'} fillRule="nonzero">
                <path
                  d="M17.9995432,32.371277 C10.6093473,32.371277 4.54389854,26.6564302 3.95722486,19.4168387 C5.27960625,19.5393839 5.36713418,20.0342778 6.14305743,20.8755975 C7.09167091,21.9078049 8.78545459,23.3170744 11.2433334,23.3170744 C13.7012122,23.3170744 14.9999374,21.9054483 15.9485509,20.8755975 C16.849852,19.8975928 17.3750196,19.3862024 18.4868608,19.3862024 C19.6010677,19.3862024 20.1238696,19.8975928 21.0275363,20.8755975 C21.9761498,21.9078049 23.2772406,23.3170744 25.7351195,23.3170744 C28.1929983,23.3170744 29.3970987,21.9078049 30.3457122,20.8755975 C31.0483012,20.1144035 31.310885,19.6407193 32.0371302,19.4639715 C31.429166,26.6823532 25.370814,32.371277 17.9995432,32.371277 M17.9995432,4.17410501 C25.1673707,4.17410501 31.0908824,9.55430925 31.9732585,16.4875378 C29.8465664,16.7373415 29.0185996,17.9604365 28.1717077,18.8795253 C27.268041,19.8598866 26.8374982,20.371277 25.7232914,20.371277 C24.6090845,20.371277 24.0744545,19.8598866 23.1684221,18.8795253 C22.2198086,17.8496745 20.8950616,16.4404051 18.4371828,16.4404051 C15.979304,16.4404051 14.6309008,17.8520312 13.6822873,18.8795253 C12.7809862,19.8598866 12.1588282,20.371277 11.046987,20.371277 C9.93278013,20.371277 9.21363175,19.8598866 8.30996504,18.8795253 C7.44178262,17.9392268 6.76758102,16.6807822 4.02582783,16.473398 C4.91530083,9.5448827 10.8364468,4.17410501 17.9995432,4.17410501 M17.9995432,0.273869347 C8.07340307,0.273869347 -0.000456829603,8.3500673 -0.000456829603,18.2738693 C-0.000456829603,28.1976714 8.07340307,36.2738693 17.9995432,36.2738693 C27.9233176,36.2738693 35.9995432,28.1976714 35.9995432,18.2738693 C35.9995432,8.3500673 27.9233176,0.273869347 17.9995432,0.273869347"
                  id="Fill-18"
                ></path>
              </g>
            </g>
          </g>
        </svg>
      </StyledNavLogo>
      <StyledNavMobileWrapper toggleNav={toggleNav}>
        <StyledNavMobile toggleNav={toggleNav}>
          {mainNavLinks.map(link => {
            return (
              <StyledNavMobileLink
                to={link.link}
                activeStyle={{
                  fontWeight: 800,
                  fontSize: '2.5rem',
                  borderBottom: 'solid 2px var(--c-white)',
                  paddingBottom: '.5rem',
                }}
                key={link.name}
              >
                {link.name}
              </StyledNavMobileLink>
            );
          })}
        </StyledNavMobile>
      </StyledNavMobileWrapper>
      <StyledNavDesktop>
        {mainNavLinks.map(link => {
          return (
            <StyledNavLink to={link.link} activeStyle={{ color: 'var(--c-red)' }} key={link.name}>
              {link.name}
            </StyledNavLink>
          );
        })}
      </StyledNavDesktop>
      <StyledNavToggle aria-hidden onClick={() => setToggleNav(!toggleNav)} toggleNav={toggleNav}>
        <svg viewBox="0 0 9 7" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/1999/xlink">
          <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="noun_menu_2492067" fill={toggleNav ? '#e84955' : '#FFFFFF'} fillRule="nonzero">
              <g id="Group">
                <path
                  d="M7,-0.5 C7,-0.77614237 7.2238576,-1 7.5,-1 C7.7761424,-1 8,-0.77614237 8,-0.5 L8,7.5 C8,7.7761424 7.7761424,8 7.5,8 C7.2238576,8 7,7.7761424 7,7.5 L7,-0.5 Z M4,-0.5 C4,-0.77614237 4.2238576,-1 4.5,-1 C4.7761424,-1 5,-0.77614237 5,-0.5 L5,7.5 C5,7.7761424 4.7761424,8 4.5,8 C4.2238576,8 4,7.7761424 4,7.5 L4,-0.5 Z M1,-0.5 C1,-0.77614237 1.22385763,-1 1.5,-1 C1.77614237,-1 2,-0.77614237 2,-0.5 L2,7.5 C2,7.7761424 1.77614237,8 1.5,8 C1.22385763,8 1,7.7761424 1,7.5 L1,-0.5 Z"
                  id="Shape"
                  transform="translate(4.500000, 3.500000) rotate(90.000000) translate(-4.500000, -3.500000) "
                ></path>
              </g>
            </g>
          </g>
        </svg>
      </StyledNavToggle>
    </StyledNavWrapper>
  );
};

export default Nav;
